// extracted by mini-css-extract-plugin
export default {"errorFallback":"ErrorFallback_errorFallback__MZLy4","errorMessage":"ErrorFallback_errorMessage__zbU+V","refresh":"ErrorFallback_refresh__wdYht"};